import React, { useEffect } from 'react'
import PageLayout from 'components/layouts/PageLayout'
import SectionLayout from 'components/layouts/SectionLayout'
import SmallBanner from 'components/SmallBanner'
import AgentContent from './content/AgentContent'
import { AgentBannerContent } from './content/banner.js'

const Agent = () => {

  useEffect(() => {
    // Change Tab Title
    document.title = "Agent - Insurance Enterprise"
  }, [])

  return (
    <>
      <SmallBanner content={AgentBannerContent} />
      <PageLayout
        content={<SectionLayout content={<AgentContent />} />}
      />
    </>
  )
}

export default Agent